import type { YardiGuestCardRow } from '../types'

/**
 * Show Invite when no Manual/Automated invite exists.
 */
export function canInviteGuestCard(
  row: Pick<YardiGuestCardRow, 'isManualInvite' | 'isAutomatedInvite'>,
): boolean {
  if (row.isManualInvite || row.isAutomatedInvite) return false
  return true
}

/** Validate API marks non-responsible occupants as warning-only and not selectable. */
export function isResponsibleForLease(
  row: Pick<YardiGuestCardRow, 'responsibleForLease'>,
): boolean {
  return row.responsibleForLease !== false
}
